import React from 'react'
import { Contributions } from 'Utilities/Plans/ContributionCalculator'
import { TieredRates } from 'Utilities/pharaoh.types'
import { Label } from 'Utilities/config'
import styles from './index.module.scss'
import Plan, { PlanBody } from 'Components/Plans/plan-subcomponents/Plan'
import PlanTitle from 'Components/Plans/plan-subcomponents/PlanTitle'
import { Member } from 'Utilities/Hooks/useStargate'
import EETierRate from './EESupplementalSubComp/EETierRate'
import BenefitComp from './EESupplementalSubComp/BenefitComp'
import BenefitAmountContainer from './EESupplementalSubComp/BenefitAmountContainer'
import benefitStyle from './EESupplementalSubComp/EESupplementalSubComp.module.scss'
import { GlobalStringConstant } from 'GlobalStringConstant'
import { PremiumSplits } from 'Components/Plans/plan-subcomponents/Plan.helpers'
import { LifeERPlan } from '../LifePlan/index.helpers'

interface Props {
  plan: { rate: TieredRates, plan: LifeERPlan, isRenewal: boolean }
  contributions: Contributions
  selected?: boolean
  label: Label
  selectHandler?(plan: LifeERPlan): void
  showWeeklyPayments: boolean
  premium?: PremiumSplits
  member: Member
}

const LifeERPlanEE: React.FC<Props> = ({ plan, selected, label, selectHandler, contributions, showWeeklyPayments, member }) => {
  const dollarAmount = plan.plan.data.benefitAmount.split(' ')[0].substring(1)
  const benefitAmountDescriptor = plan.plan.data.benefitAmount.split(/(?<=^\S+)\s/)[1]
  const sbc = plan.plan.data.sbc

  return <Plan selected={!!selected} noMovement>
    <PlanTitle
      available={false}
      carrier= {plan.plan.carrier}
      id={plan.plan.id}
      includesProsperBenefits={false}
      label={label}
      planName={plan.plan.name}
      planType={plan.plan.type}
      sbc={sbc}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
      selected={selected}
    />
    <PlanBody noWrap={true} planType={plan.plan.type}>
      <EETierRate
        plan={plan}
        contributions={contributions}
        showWeeklyPayments={showWeeklyPayments}
        member={member}
        showAfterEmpCont={false}
        onlyIndividual
      />
      <BenefitComp amountLabel={benefitAmountDescriptor} name={GlobalStringConstant[0].benefit_amount} benefitAmount={dollarAmount}/>
      <div className={styles.vertContainer}>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].accidental_death_and_dismemberment}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              <span className={benefitStyle.amount}>{plan.plan.data.accidentalDeathAndDismemberment}</span>
            </div>
          </div>
        </BenefitAmountContainer>
        <BenefitAmountContainer>
          <div className={styles.vertFlex}>
            <div className={benefitStyle.benefitBoxTitle}>{GlobalStringConstant[0].conversion}</div>
            <div className={`${benefitStyle.accidental_death_price} ${benefitStyle.hospital_benifit_amount}`}>
              <span className={benefitStyle.amount}>{plan.plan.data.conversion}</span>
            </div>
          </div>
        </BenefitAmountContainer>
      </div>
    </PlanBody>
  </Plan>
}

export default LifeERPlanEE
